import { View } from "react-native";
import { ChannelEditorScreen } from "open-modules/zdf/component/channeleditor";
import { UtilityText } from "component/text";

export const ChannelStructure = {
    key: "channel",
    name: "Channel",
    screen: ChannelScreen,
    subscreens: {
        edit: ChannelEditorScreen,
    },
    defaultConfig: {},
};

function ChannelScreen() {
    return <View>
        <UtilityText text="Channel has no screen" />
    </View>
}